import { loadAbort } from '@/utils';
import { strapiInstance } from '@/constants/axios.instances.constants';
import { juntaDirectivaMapper } from '@/mappers';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import type { JuntaDirectiva } from '@/interfaces/strapi';

export const getJuntaDirectiva = (): UseApiCall<JuntaDirectiva[]> => {
	const controller = loadAbort();
	const url = '/junta-directivas/get';

	return {
		call: strapiInstance.get<JuntaDirectiva[]>(url, {
			signal: controller.signal,
			transformResponse: [(data: string) => juntaDirectivaMapper(JSON.parse(data))],
		}),
		controller,
	};
};
